import * as commonMutations from './common'

export default {
    ...commonMutations.default,
}
